(function () {
  'use strict';

  var root = document.querySelector('[data-palmr-cart-drawer]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var isLoading = false;
  var lastFocus = null;

  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  function moneyFormat(cents) {
    var dollars = Math.max(0, cents / 100);
    if (dollars === Math.floor(dollars)) return '$' + dollars.toFixed(0);
    return '$' + dollars.toFixed(2);
  }

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = $('.palmr-cd__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('palmr:cart-drawer:opened'));
    loadRecommendations();
    getCart().then(function (cart) {
      syncCartCount(cart);
      updateRewardBar(cart);
      renderDiscountStatus(cart);
      loadBundleUpsells(cart);
      loadVolumeBundleProgress(cart);
      fetchShippingEstimate(cart);
      if (cart.item_count > 0) klaviyoTrack('Viewed Cart', buildCartPayload(cart));
    }).catch(function () {});
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    ['1', '2'].forEach(function (tier) {
      if (giftChanging[tier]) setGiftChanging(tier, false);
    });
    giftPreview['1'] = false; giftPreview['2'] = false; // collapse any locked previews
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('palmr:cart-drawer:closed'));
  }

  function setLoading(loading) {
    isLoading = loading;
    root.classList.toggle('is-loading', loading);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  /* ---------- Klaviyo tracking ---------- */
  function klaviyoEnabled() {
    return root.getAttribute('data-klaviyo-enable') === 'true';
  }
  function klaviyoTrack(event, payload) {
    if (!klaviyoEnabled()) return;
    try {
      window._learnq = window._learnq || [];
      var email = root.getAttribute('data-customer-email');
      if (email) {
        window._learnq.push(['identify', { '$email': email }]);
      }
      window._learnq.push(['track', event, payload]);
    } catch (e) {}
  }
  function buildCartPayload(cart, addedItem) {
    var items = (cart.items || []).map(function (i) {
      return {
        ProductID: i.product_id,
        SKU: i.sku,
        ProductName: i.product_title,
        Quantity: i.quantity,
        ItemPrice: i.price / 100,
        RowTotal: i.line_price / 100,
        ProductURL: location.origin + i.url,
        ImageURL: i.image,
        ProductCategories: i.product_type ? [i.product_type] : []
      };
    });
    var payload = {
      $value: cart.total_price / 100,
      ItemNames: items.map(function (i) { return i.ProductName; }),
      CheckoutURL: location.origin + '/cart',
      Items: items
    };
    if (addedItem) {
      payload.AddedItemProductName = addedItem.product_title || addedItem.title;
      payload.AddedItemProductID = addedItem.product_id || addedItem.id;
      payload.AddedItemSKU = addedItem.sku;
      payload.AddedItemPrice = (addedItem.price || 0) / 100;
      payload.AddedItemQuantity = addedItem.quantity || 1;
      payload.AddedItemImageURL = addedItem.image;
      payload.AddedItemProductCategories = addedItem.product_type ? [addedItem.product_type] : [];
      payload.AddedItemURL = addedItem.url ? (location.origin + addedItem.url) : '';
    }
    return payload;
  }

  function syncCartCount(cart) {
    if (!cart || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
    document.querySelectorAll('.cart-link__count').forEach(function (badge) {
      badge.textContent = cart.item_count > 0 ? String(cart.item_count) : '';
    });
    var count = $('[data-palmr-cd-count]');
    if (count) count.textContent = String(cart.item_count);
  }

  function refresh() {
    setLoading(true);
    return fetch('/?section_id=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-palmr-cart-drawer]');
        if (!fresh) return;

        var bodyNew = fresh.querySelector('[data-palmr-cd-body]');
        var footerNew = fresh.querySelector('[data-palmr-cd-footer]');
        var countNew = fresh.querySelector('[data-palmr-cd-count]');

        if (bodyNew) $('[data-palmr-cd-body]').innerHTML = bodyNew.innerHTML;
        if (footerNew) {
          var footer = $('[data-palmr-cd-footer]');
          footer.innerHTML = footerNew.innerHTML;
          if (footerNew.hasAttribute('hidden')) footer.setAttribute('hidden', '');
          else footer.removeAttribute('hidden');
        }
        if (countNew && $('[data-palmr-cd-count]')) {
          $('[data-palmr-cd-count]').textContent = countNew.textContent;
        }
        // The reward element is deliberately NOT swapped: its server markup is
        // all settings-driven (thresholds, labels) while everything cart-driven
        // (fill width, message, marker states) is painted by updateRewardBar.
        // Replacing it reset the fill to the CSS-default 0% and restarted the
        // width transition, so every cart change showed a full bar collapsing
        // to empty and re-animating up.
        if (root.classList.contains('is-open')) loadRecommendations();
        return getCart().then(function (cart) {
          syncCartCount(cart);
          updateRewardBar(cart);
          syncTbt1Gift(cart);
          renderDiscountStatus(cart);
          updateGiftPickers(cart);
          loadBundleUpsells(cart);
          loadVolumeBundleProgress(cart);
          fetchShippingEstimate(cart);
        });
      })
      .catch(function (err) {
        console.warn('[palmr-cd] refresh failed', err);
        showError("Your cart may be out of date. Please reload the page.");
      })
      .finally(function () { setLoading(false); });
  }

  /* ---------- Free gift system ---------- */
  // Qualifying total uses final_line_price (post-discount) so applied codes
  // "cost" gift progress — customer must spend more to reach a tier after a code.
  function getGiftState(cart) {
    var giftLines = { '1': [], '2': [] };
    var qualifyingTotal = 0;
    (cart.items || []).forEach(function (item) {
      var tier = item.properties && item.properties._gift_tier;
      var lineFinal = (item.final_line_price != null) ? item.final_line_price
                    : (item.line_price != null) ? item.line_price
                    : (item.price * item.quantity);
      var lineOriginal = item.original_line_price || (item.original_price * item.quantity);
      // Any tier is excluded from the qualifying total, not just the two with a
      // bucket here. The old `tier && giftLines[tier]` test meant a tier this
      // object doesn't track (e.g. the Onboard "tbt1" keychain) fell through to
      // the else and counted its price toward $75/$150 — free product pushing
      // the shopper up the ladder they hadn't paid for.
      if (tier) {
        if (giftLines[String(tier)]) {
          giftLines[String(tier)].push({ key: item.key, qty: item.quantity, price: lineOriginal });
        }
      } else {
        qualifyingTotal += lineFinal;
      }
    });
    return { lines: giftLines, qualifyingTotal: qualifyingTotal };
  }

  /* ---------- Unclaimed-gift surfacing ----------
     Replaces the old "Maybe later" dismissal (sessionStorage-backed), removed
     2026-08-16. Measured attach among orders that EARNED a gift was 50-64%:
     a third of shoppers paid for the threshold and took nothing. Dismissing an
     earned gift is never the shopper's goal — they just don't see it — so the
     picker now opens itself and comes to them instead of waiting to be found.

     Deliberately NOT auto-adding a $0 line: every product in the gift pool is
     multi-variant (tees S-3XL, hats Standard/Small Fit), so a pre-added line
     would be choosing the shopper's size for them and shipping the wrong one
     whenever they didn't notice. */

  /* ---------- Touched By Type 1 keychain auto-gift, 2026-08-21 ----------
     The 25 Years tees earn one free TBT1 keychain, no spend threshold.

     This one IS auto-added, unlike the $75/$150 pool above, and the reason is the
     note above: that pool is all multi-variant, so a pre-added line would be
     picking the shopper's size. The keychain is single-variant — there is nothing
     to get wrong — so the gift can just appear.

     Declining is removal, matching the rest of this drawer ("removing IS how you
     decline now"). The flag is sessionStorage, not localStorage: a shopper who
     doesn't want it today shouldn't be permanently cut off from it next visit. */
  var TBT1_GIFT_TIER = 'tbt1';
  var TBT1_KEYCHAIN_VARIANT_ID = 47153695719591;

  // SCOPE CORRECTED 2026-08-21: shipped first as "any Touched By Type 1 product,"
  // which overshot what TBT1 asked for. The offer is the 25 Years tee only, so
  // this is an allowlist, not a vendor match. The Dancing For Diabetes 25 Years
  // Tee (8614086705319) is deliberately out: same words in the name, different
  // design.
  //
  // Keep in lockstep with TBT1_TRIGGER_PRODUCT_IDS in the free-gift Function
  // (apps/palmr-discounts/extensions/free-gift-discount/src/
  //  cart_lines_discounts_generate_run.js). If the lists disagree, this adds a
  // keychain the Function refuses to zero and the shopper gets a "Gift discount
  // not yet applied" warning on a line they never asked for.
  var TBT1_TRIGGER_PRODUCT_IDS = [
    8555089920167, // The 25 Years Tee (adult)
    8555090280615  // Youth 25 Years Tee
  ];

  var TBT1_DECLINED_KEY = 'palmr_tbt1_gift_declined_v1';
  var tbt1AddInFlight = false;
  // Latched on any add failure — almost always a stock-out (inventory policy is
  // DENY). Without it every cart render re-attempts a 422 for the rest of the visit.
  var tbt1AddFailed = false;

  function tbt1Declined() {
    try { return sessionStorage.getItem(TBT1_DECLINED_KEY) === '1'; }
    catch (e) { return false; }
  }
  function setTbt1Declined() {
    try { sessionStorage.setItem(TBT1_DECLINED_KEY, '1'); } catch (e) {}
  }
  function clearTbt1Declined() {
    try { sessionStorage.removeItem(TBT1_DECLINED_KEY); } catch (e) {}
  }

  function tbt1GiftLine(cart) {
    var found = null;
    (cart.items || []).forEach(function (i) {
      if (i.properties && i.properties._gift_tier === TBT1_GIFT_TIER) found = i;
    });
    return found;
  }

  // A trigger is a paid 25 Years tee line. Gift lines are skipped so a gift can
  // never qualify itself.
  function hasTbt1Trigger(cart) {
    return (cart.items || []).some(function (i) {
      if (i.properties && i.properties._gift_tier) return false;
      return TBT1_TRIGGER_PRODUCT_IDS.indexOf(i.product_id) !== -1;
    });
  }

  function syncTbt1Gift(cart) {
    // An empty cart ends the shopping trip, so a decline made during it stops
    // applying. The decline is scoped to "this order", not "this tab": without
    // this the flag outlived the cart entirely — decline once, check out, start
    // a fresh order in the same tab, and the keychain never came back. Checkout
    // empties the cart too, so the next order starts clean.
    if (!(cart.items || []).length) clearTbt1Declined();

    var gift = tbt1GiftLine(cart);
    var trigger = hasTbt1Trigger(cart);

    // Trigger gone (last Onboard item removed) — take the keychain back, or the
    // shopper checks out with a line the Function will no longer zero. This is
    // NOT a decline and must not set the flag: re-adding an Onboard item should
    // bring the keychain back with it.
    if (gift && !trigger) return changeLine(gift.key, 0);

    if (!trigger || gift || tbt1AddInFlight || tbt1AddFailed || tbt1Declined()) return;

    tbt1AddInFlight = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: TBT1_KEYCHAIN_VARIANT_ID,
        quantity: 1,
        properties: { '_gift_tier': TBT1_GIFT_TIER }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed: ' + res.status);
        // The /cart page is server-rendered and refresh() only repaints the
        // drawer, so there the new line would stay invisible until the next
        // navigation. Reloading is safe from looping: on the way back the gift
        // already exists, so this branch never runs twice.
        if (/^\/cart(\/|$)/.test(location.pathname)) { location.reload(); return; }
        return refresh();
      })
      .catch(function (err) {
        // Silent by design. The keychain is a bonus the shopper never asked for,
        // so a stock-out must not throw an error banner over their real cart.
        tbt1AddFailed = true;
        console.warn('[palmr-cd] TBT1 keychain auto-add failed', err);
      })
      .finally(function () { tbt1AddInFlight = false; });
  }

  // Per-tier qualification on the PREVIOUS render. null = first render, so a
  // cart that already qualifies on open does not yank the drawer around.
  // Tracks qualification only (not claimed-ness) so that removing a gift line
  // never re-triggers the reveal — removing IS how you decline now.
  var giftQualifiedPrev = { '1': null, '2': null };

  function revealPicker(picker) {
    if (!picker) return;
    try { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    catch (e) { picker.scrollIntoView(); }
    flashEl(picker);
  }

  // Bundle upsell dismissal — localStorage (persists across sessions). If a
  // shopper says "no thanks" we should remember it next visit, not nag them.
  var BUNDLE_DISMISS_KEY = 'palmr_bundle_dismissed_v1';
  function getDismissedBundleIds() {
    try {
      var raw = localStorage.getItem(BUNDLE_DISMISS_KEY);
      if (!raw) return {};
      var obj = JSON.parse(raw);
      return obj && typeof obj === 'object' ? obj : {};
    } catch (e) { return {}; }
  }
  function setBundleDismissed(bundleId) {
    if (!bundleId) return;
    try {
      var current = getDismissedBundleIds();
      current[bundleId] = Date.now();
      localStorage.setItem(BUNDLE_DISMISS_KEY, JSON.stringify(current));
    } catch (e) {}
  }

  // Tiers the shopper opened as a locked preview from the reward bar (in-memory;
  // cleared when the drawer closes). Lets them see the gift before it's unlocked.
  var giftPreview = { '1': false, '2': false };
  var giftChanging = { '1': false, '2': false };
  var giftCollapsed = { '1': false, '2': false };
  try {
    var savedGiftCollapse = JSON.parse(sessionStorage.getItem('palmr_gift_collapsed_v1') || '{}');
    giftCollapsed['1'] = savedGiftCollapse['1'] === true;
    giftCollapsed['2'] = savedGiftCollapse['2'] === true;
  } catch (e) {}

  function setGiftCollapsed(tier, collapsed) {
    if (tier !== '1' && tier !== '2') return;
    giftCollapsed[tier] = collapsed;
    try { sessionStorage.setItem('palmr_gift_collapsed_v1', JSON.stringify(giftCollapsed)); } catch (e) {}
    var picker = $('[data-palmr-cd-gift-picker="' + tier + '"]');
    if (!picker) return;
    var choices = $('[data-palmr-cd-gift-choices]', picker);
    var toggle = $('[data-palmr-cd-gift-collapse]', picker);
    picker.classList.toggle('is-collapsed', collapsed);
    if (choices) choices.hidden = collapsed;
    if (toggle) {
      toggle.textContent = toggle.getAttribute(collapsed ? 'data-show-label' : 'data-hide-label');
      toggle.setAttribute('aria-expanded', String(!collapsed));
    }
  }

  function setGiftChanging(tier, changing) {
    if (tier !== '1' && tier !== '2') return;
    if (changing && (isLoading || giftQualifiedPrev[tier] === false)) return;
    var picker = $('[data-palmr-cd-gift-picker="' + tier + '"]');
    if (!picker) return;
    giftChanging[tier] = changing;
    var collapseToggle = $('[data-palmr-cd-gift-collapse]', picker);
    if (collapseToggle) collapseToggle.hidden = changing;
    picker.toggleAttribute('hidden', !changing);
    var cancel = $('[data-palmr-cd-gift-cancel]', picker);
    if (cancel) cancel.toggleAttribute('hidden', !changing);
    var change = $('[data-palmr-cd-gift-change="' + tier + '"]');
    if (change) change.setAttribute('aria-expanded', String(changing));
    if (changing) {
      setGiftCollapsed(tier, false);
      picker.classList.remove('is-locked', 'is-collapsed');
      setGiftControlsDisabled(picker, false);
      revealPicker(picker);
      if (cancel) cancel.focus({ preventScroll: true });
    } else {
      $$('select[data-palmr-cd-gift-pick]', picker).forEach(function (select) { select.value = ''; });
      if (change) change.focus({ preventScroll: true });
    }
  }

  function setGiftControlsDisabled(picker, disabled) {
    Array.prototype.forEach.call(picker.querySelectorAll('[data-palmr-cd-gift-pick]'), function (c) {
      // A grouped row keeps EVERY colourway's pick control in the DOM and reveals
      // one at a time, so hidden always wins over the unlock pass. Without this,
      // unlocking a tier re-enables the colourways the shopper didn't choose —
      // harmless only for as long as [hidden] keeps them out of the tab order.
      if (disabled || c.hasAttribute('hidden')) c.setAttribute('disabled', '');
      else c.removeAttribute('disabled');
    });
  }

  // Resolve a grouped gift row to the single member product matching the current
  // pill selection across every dimension, and reveal that member's pane.
  //
  // A group can vary on more than one axis — the Ace Dress is Colour x Fit, 4 x 2 —
  // so a selection is a COMBINATION, not an index. Coordinates live in the DOM as
  // data-dim1..3 on each pick control (written by snippets/palmr-gift-picker-list
  // .liquid); nothing here knows about products or variants.
  function selectGiftGroupMember(group, changedDim, changedValue) {
    var rows = $$('[data-gift-dim]', group);
    if (!rows.length) return;

    var want = {};
    rows.forEach(function (row) {
      var dim = row.getAttribute('data-gift-dim');
      var pressed = row.querySelector('[aria-pressed="true"]');
      want[dim] = pressed ? pressed.getAttribute('data-value') : null;
    });
    if (changedDim) want[changedDim] = changedValue;
    var dims = Object.keys(want);

    // Pick controls are the only panes carrying coordinates.
    var coords = $$('[data-gift-pane][data-dim1]', group);
    if (!coords.length) return;

    var match = null;
    coords.some(function (pane) {
      var hit = dims.every(function (d) { return pane.getAttribute('data-dim' + d) === want[d]; });
      if (hit) match = pane;
      return hit;
    });
    // Incomplete matrix: the chosen colour may not exist in the chosen fit. Honour
    // the axis the shopper just touched and let the other one move, rather than
    // dead-clicking the pill.
    if (!match && changedDim) {
      coords.some(function (pane) {
        var hit = pane.getAttribute('data-dim' + changedDim) === changedValue;
        if (hit) match = pane;
        return hit;
      });
    }
    if (!match) match = coords[0];

    var idx = match.getAttribute('data-gift-pane');
    $$('[data-gift-pane]', group).forEach(function (pane) {
      var on = pane.getAttribute('data-gift-pane') === idx;
      if (on) pane.removeAttribute('hidden');
      else pane.setAttribute('hidden', '');
      // Hidden selects must also be disabled, or a keyboard user can still tab into
      // a colourway they didn't choose and add the wrong gift.
      if (pane.tagName === 'SELECT') {
        pane.disabled = !on;
        if (on) pane.selectedIndex = 0;
      }
    });

    // Re-sync EVERY pill row to the member actually resolved. Without this the
    // fallback above would leave a pill lit for a combination that isn't on screen.
    rows.forEach(function (row) {
      var dim = row.getAttribute('data-gift-dim');
      var actual = match.getAttribute('data-dim' + dim);
      $$('[data-palmr-cd-gift-swatch]', row).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-value') === actual ? 'true' : 'false');
      });
    });
  }

  /* ---------- Onboard-first gift ordering, 2026-08-21 ----------
     The gift pickers render in gift-collection order, which put the T1D
     Heritage Hat below the Florida and 407 hats on the very pages where it is
     the most relevant gift. This floats Onboard-vendored gifts to the top of
     each picker on Onboard surfaces, leaving relative order otherwise intact
     and leaving Palmr pages exactly as they were.

     Deliberately JS and not Liquid: refresh() re-renders this section against
     '/' through the Section Rendering API, so the homepage's context is what
     the drawer body is rebuilt from. Page-conditional Liquid inside the drawer
     would therefore be correct on first paint and silently revert on the first
     cart change. The onboard-chrome body class is page-level and survives every
     refresh, so re-applying the sort here holds for the life of the page. */
  var ONBOARD_GIFT_VENDOR = 'Onboard by Palmr';

  function promoteOnboardGifts() {
    if (!document.body.classList.contains('onboard-chrome')) return;
    $$('[data-palmr-cd-gift-list]').forEach(function (list) {
      var rows = $$('[data-gift-vendor]', list);
      // Walk backwards and prepend, so several Onboard rows keep the order the
      // collection put them in rather than ending up reversed.
      for (var i = rows.length - 1; i >= 0; i--) {
        if (rows[i].getAttribute('data-gift-vendor') === ONBOARD_GIFT_VENDOR) {
          list.insertBefore(rows[i], list.firstElementChild);
        }
      }
    });
  }

  function updateGiftPickers(cart) {
    promoteOnboardGifts();
    if (cart.item_count === 0) {
      setGiftCollapsed('1', false);
      setGiftCollapsed('2', false);
    }
    var state = getGiftState(cart);
    var reward = $('[data-palmr-cd-reward]');
    ['1', '2'].forEach(function (tier) {
      var picker = $('[data-palmr-cd-gift-picker="' + tier + '"]');
      if (!picker) return;
      var threshold = parseInt(picker.getAttribute('data-threshold'), 10);
      var qualifies = state.qualifyingTotal >= threshold;
      var hasGift = state.lines[tier].length > 0;
      if (!qualifies || !hasGift) giftChanging[tier] = false;
      var changing = giftChanging[tier];
      var collapseToggle = $('[data-palmr-cd-gift-collapse]', picker);
      if (collapseToggle) collapseToggle.hidden = changing;
      var cancel = $('[data-palmr-cd-gift-cancel]', picker);
      if (cancel) cancel.toggleAttribute('hidden', !changing);
      var change = $('[data-palmr-cd-gift-change="' + tier + '"]');
      if (change) change.setAttribute('aria-expanded', String(changing));

      if (qualifies && (!hasGift || changing)) {
        giftPreview[tier] = false;
        picker.classList.remove('is-locked', 'is-collapsed');
        setGiftControlsDisabled(picker, false);
        picker.removeAttribute('hidden');
        // Fired only on the render where this tier newly qualifies, and only
        // while the drawer is actually on screen.
        if (!giftCollapsed[tier] && giftQualifiedPrev[tier] === false && root.classList.contains('is-open')) {
          revealPicker(picker);
        }
      } else if (!hasGift && giftPreview[tier]) {
        // Locked preview — show the options to build desire, but disable adding.
        picker.classList.add('is-locked');
        picker.classList.remove('is-collapsed');
        setGiftControlsDisabled(picker, true);
        var lockText = $('[data-palmr-cd-gift-locked-text]', picker);
        if (lockText) {
          var tpl = (reward && reward.getAttribute('data-tier' + tier + '-pending')) || 'Add {{amount}} more to unlock';
          lockText.textContent = tpl.replace('{{amount}}', moneyFormat(Math.max(0, threshold - state.qualifyingTotal)));
        }
        picker.removeAttribute('hidden');
      } else {
        // Hidden — not qualified and not previewing, or already claimed.
        picker.classList.remove('is-locked', 'is-collapsed');
        setGiftControlsDisabled(picker, false);
        picker.setAttribute('hidden', '');
      }

      setGiftCollapsed(tier, changing ? false : giftCollapsed[tier]);

      if (!qualifies && hasGift) {
        state.lines[tier].forEach(function (g) { silentRemoveLine(g.key); });
      }
      giftQualifiedPrev[tier] = qualifies;
    });
    syncUpsellPriority();
  }

  function silentRemoveLine(key) {
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { return refresh(); }).catch(function () {});
  }

  function pickGift(tier, variantId) {
    if (!variantId || isLoading) return Promise.resolve();
    setLoading(true);
    var errorBanner = $('[data-palmr-cd-error]');
    if (errorBanner) errorBanner.setAttribute('hidden', '');
    var fallback = root.getAttribute('data-gift-error');
    function readGiftResponse(res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status >= 400) {
          var error = new Error('Gift request failed');
          error.giftMessage = typeof data.description === 'string' ? data.description : fallback;
          throw error;
        }
        return data;
      });
    }
    return getCart().then(function (cart) {
      var alreadySelected = (cart.items || []).some(function (i) {
        return String(i.properties && i.properties._gift_tier) === String(tier) &&
          String(i.variant_id) === String(variantId);
      });
      if (alreadySelected) return;
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: { '_gift_tier': String(tier) } })
      }).then(readGiftResponse);
    }).then(function () {
      return getCart();
    }).then(function (cart) {
      var replacementPresent = (cart.items || []).some(function (i) {
        return String(i.properties && i.properties._gift_tier) === String(tier) &&
          String(i.variant_id) === String(variantId) && i.quantity > 0;
      });
      if (!replacementPresent) throw new Error('Gift replacement was not confirmed');
      var updates = {};
      (cart.items || []).forEach(function (i) {
        if (String(i.properties && i.properties._gift_tier) === String(tier) &&
            String(i.variant_id) !== String(variantId)) updates[i.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(readGiftResponse);
    }).then(function () {
      giftChanging[tier] = false;
      return refresh();
    }).catch(function (err) {
      console.warn('[palmr-cd] gift pick failed', err);
      return refresh().then(function () {
        showError(err.giftMessage || fallback, true);
      });
    }).finally(function () {
      setLoading(false);
      $$('[data-palmr-cd-gift-picker]').forEach(function (picker) {
        setGiftControlsDisabled(picker, picker.classList.contains('is-locked'));
        $$('select[data-palmr-cd-gift-pick]', picker).forEach(function (select) {
          select.value = '';
        });
      });
    });
  }

  // Inline, screen-reader-announced error banner under the drawer header.
  // Every fetch failure used to revert silently; the shopper never learned
  // the action didn't happen.
  var errTimer;
  function showError(msg, persistent) {
    var el = $('[data-palmr-cd-error]');
    if (!el) return;
    el.textContent = msg;
    el.removeAttribute('hidden');
    clearTimeout(errTimer);
    if (!persistent) errTimer = setTimeout(function () { el.setAttribute('hidden', ''); }, 5000);
  }

  // Positive counterpart to showError. The error banner is red (#fbeaea /
  // #8a2b2b) — wrong register for "you've earned something," which is why this
  // is a separate element rather than a reuse.
  var noticeTimer;
  function showNotice(msg) {
    var el = $('[data-palmr-cd-notice]');
    if (!el) return;
    el.textContent = msg;
    el.removeAttribute('hidden');
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () { el.setAttribute('hidden', ''); }, 6000);
  }

  // Brief attention flash for an element the user was just jumped to (or nudged toward).
  function flashEl(el) {
    if (!el) return;
    el.classList.remove('palmr-cd--flash');
    void el.offsetWidth; // restart the CSS animation
    el.classList.add('palmr-cd--flash');
    setTimeout(function () { el.classList.remove('palmr-cd--flash'); }, 1100);
  }

  /* ---------- Action headline ----------
     "One more hat → free gift" instead of "Add $9 more". Shopee states its
     goal as "5 more order(s)" — units the shopper already thinks in — and that
     removes the arithmetic step entirely. Palmr can do the same because every
     hat is the same price.

     The headline is only rendered when it is VERIFIABLY true: adding one more
     of the cheapest thing already in the cart must actually cross the tier.
     Anything short of that and it returns '' and the dollar message carries it
     alone. This offer's credibility rests on numbers being checkable, so the
     failure mode has to be silence, never an approximation. */

  function singularNoun(t) {
    t = String(t || '').trim().toLowerCase();
    // Plurale tantum — no singular exists ("one more short", "one more
    // sunglasse"). The unit a shopper actually adds is a pair.
    if (/(?:shorts|pants|joggers|glasses|leggings)$/.test(t)) return 'pair of ' + t;
    if (/sses$/.test(t)) return t.slice(0, -2);           // dresses -> dress
    if (t.length > 3 && t.slice(-1) === 's') return t.slice(0, -1);
    return t;
  }

  // Cheapest per-unit non-gift line — the easiest "one more" to satisfy, so
  // the claim is as likely to hold as the cart allows.
  function cheapestCartUnit(cart) {
    var best = null;
    (cart.items || []).forEach(function (i) {
      if (i.properties && i.properties._gift_tier) return;
      var unit = (i.final_price != null) ? i.final_price : i.price;
      if (!unit || unit <= 0) return;
      if (!best || unit < best.price) best = { price: unit, type: i.product_type };
    });
    return best;
  }

  function buildActionHeadline(cart, total, tiers, nextIdx, reward) {
    if (reward.getAttribute('data-action-enable') !== 'true') return '';
    if (nextIdx === -1) return '';           // everything earned; message says so
    var unit = cheapestCartUnit(cart);
    if (!unit) return '';
    var noun = singularNoun(unit.type);
    if (!noun) return '';

    // Never invite an add that loses money: the same floor the gap rail uses.
    var recsEl = $('[data-palmr-cd-recs]');
    var floor = (recsEl ? (parseInt(recsEl.getAttribute('data-gap-floor'), 10) || 20) : 20) * 100;
    if (unit.price < floor) return '';

    var projected = total + unit.price;
    var crossed = tiers.filter(function (t) {
      return t.amount > total && t.amount <= projected;
    });
    if (!crossed.length) return '';          // one more wouldn't get there

    function labelOf(t) {
      var key = t.key === 'shipping' ? 'data-shipping-label' : ('data-tier' + t.key + '-label');
      return (reward.getAttribute(key) || '').toLowerCase();
    }
    var tpl = crossed.length >= 2
      ? (reward.getAttribute('data-action-double') || '')
      : (reward.getAttribute('data-action-single') || '');
    if (!tpl) return '';
    return tpl
      .replace(/\{\{unit\}\}/g, noun)
      .replace(/\{\{reward\}\}/g, labelOf(crossed[0]))
      .replace(/\{\{reward2\}\}/g, labelOf(crossed[1] || crossed[0]));
  }

  function updateRewardBar(confirmedCart) {
    var reward = $('[data-palmr-cd-reward]');
    if (!reward) return;
    var shipping = parseInt(reward.getAttribute('data-shipping'), 10) || 0;
    var tier1 = parseInt(reward.getAttribute('data-tier1'), 10) || 0;
    var tier2 = parseInt(reward.getAttribute('data-tier2'), 10) || 0;
    var hasShipping = shipping > 0;
    var hasTier2 = tier2 > 0;
    if (!tier1) return;

    // Build ordered list of enabled tiers. All rungs render at once (the
    // two-node sliding window was reverted 2026-08-16).
    var tiers = [];
    if (hasShipping) tiers.push({ key: 'shipping', amount: shipping });
    tiers.push({ key: '1', amount: tier1 });
    if (hasTier2) tiers.push({ key: '2', amount: tier2 });

    return (confirmedCart ? Promise.resolve(confirmedCart) : getCart()).then(function (cart) {
      // Qualifying total = sum of POST-DISCOUNT non-gift line prices. Codes reduce
      // gift progress; customer must spend more to hit a tier after applying one.
      var total = 0;
      (cart.items || []).forEach(function (i) {
        if (i.properties && i.properties._gift_tier) return;
        var f = (i.final_line_price != null) ? i.final_line_price
              : (i.line_price != null) ? i.line_price
              : (i.price * i.quantity);
        total += f;
      });

      // Find the next pending tier (first tier whose amount > total)
      var nextIdx = -1;
      for (var ni = 0; ni < tiers.length; ni++) {
        if (total < tiers[ni].amount) { nextIdx = ni; break; }
      }

      // ---- Every rung visible -------------------------------------------
      // Reverted from the two-node sliding window 2026-08-16. That window
      // existed because a 4px hairline could not carry three legible nodes —
      // the panel design can, now that each marker is labelled with its
      // threshold. Hiding $150 until $75 was cleared also left the second gift
      // undiscoverable, and tier-2 attach is the weakest number in the ladder.
      var positions = tiers.length === 1 ? [92]
                    : tiers.length === 2 ? [50, 92]
                    : [30, 55, 92];
      tiers.forEach(function (t, i) { t.position = positions[i]; });

      // Piecewise-linear across every rung: each segment maps its dollar span
      // onto its position span. Monotonic by construction — with all rungs on
      // screen there is no re-scoping, so the fill never moves backward.
      var pct = 0;
      if (total <= 0) {
        pct = 0;
      } else if (total >= tiers[tiers.length - 1].amount) {
        pct = 100;
      } else {
        for (var pi = 0; pi < tiers.length; pi++) {
          if (total < tiers[pi].amount) {
            var prevPos = pi === 0 ? 0 : tiers[pi - 1].position;
            var prevAmt = pi === 0 ? 0 : tiers[pi - 1].amount;
            pct = prevPos +
                  ((total - prevAmt) / (tiers[pi].amount - prevAmt)) *
                  (tiers[pi].position - prevPos);
            break;
          }
        }
      }

      var fill = $('[data-palmr-cd-reward-fill]');
      var msg = $('[data-palmr-cd-reward-message]');
      if (fill) fill.style.width = Math.round(pct) + '%';

      var headEl = $('[data-palmr-cd-reward-headline]');
      if (headEl) {
        var head = buildActionHeadline(cart, total, tiers, nextIdx, reward);
        headEl.textContent = head;
        if (head) headEl.removeAttribute('hidden');
        else headEl.setAttribute('hidden', '');
      }

      // Every enabled rung renders. Markers for tiers that are switched off are
      // never in the DOM, so nothing needs hiding here.
      tiers.forEach(function (t) {
        var state = total >= t.amount ? 'achieved' : 'pending';
        var marker = $('[data-palmr-cd-reward-marker="' + t.key + '"]');
        if (marker) {
          marker.hidden = false;
          marker.style.left = t.position + '%';
          marker.setAttribute('data-state', state);
        }
        var chip = $('[data-palmr-cd-reward-tier="' + t.key + '"]');
        if (chip) { chip.hidden = false; chip.setAttribute('data-state', state); }
      });

      if (!msg) return;

      var template = '';
      if (nextIdx === -1) {
        // All tiers achieved
        template = hasTier2
          ? (reward.getAttribute('data-all-achieved') || '')
          : (reward.getAttribute('data-tier1-achieved') || '');
        msg.textContent = template;
      } else {
        var nextTier = tiers[nextIdx];
        var prevTier = nextIdx > 0 ? tiers[nextIdx - 1] : null;
        var amountNeeded = nextTier.amount - total;

        if (nextTier.key === 'shipping') {
          template = reward.getAttribute('data-shipping-pending') || '';
        } else if (nextTier.key === '1') {
          if (prevTier && prevTier.key === 'shipping') {
            template = reward.getAttribute('data-shipping-to-gift') || reward.getAttribute('data-tier1-pending') || '';
          } else {
            template = reward.getAttribute('data-tier1-pending') || '';
          }
        } else if (nextTier.key === '2') {
          template = reward.getAttribute('data-tier1-achieved') || reward.getAttribute('data-tier2-pending') || '';
        }

        msg.textContent = template.replace('{{amount}}', moneyFormat(amountNeeded));
      }
      var gifts = getGiftState(cart).lines;
      var firstClaimed = total >= tier1 && gifts['1'].length > 0;
      var secondClaimed = hasTier2 && total >= tier2 && gifts['2'].length > 0;
      if (total >= tier1) {
        var claimKey = '';
        if (hasTier2 && total >= tier2) {
          claimKey = firstClaimed && secondClaimed ? 'data-gifts-claimed'
            : firstClaimed || secondClaimed ? 'data-gift-one-unclaimed' : 'data-gifts-unclaimed';
        } else if (firstClaimed) {
          claimKey = hasTier2 ? 'data-gift-claimed-progress' : 'data-gift-claimed';
        }
        if (claimKey) {
          msg.textContent = (reward.getAttribute(claimKey) || '').replace('[amount]', moneyFormat(tier2 - total));
        }
      }
    }).catch(function () {});
  }

  /* ---------- Recommendations ---------- */
  var recsLoadedForProduct = null;
  // Raw affinity pool for recsLoadedForProduct, kept so the gap filter can be
  // re-applied on every cart change without another network round-trip.
  var recsProductCache = null;
  var KIDS_RE = /\b(kid|kids|boy|boys|girl|girls|youth|child|children|toddler|baby|infant)\b/i;
  var ADULTS_RE = /\b(men|mens|women|womens|adult|adults|unisex)\b/i;

  function detectCartCategory(cart) {
    if (!cart || !cart.items || cart.items.length === 0) return 'mixed';
    var k = 0, a = 0;
    cart.items.forEach(function (item) {
      var text = ((item.product_title || '') + ' ' + (item.url || '') + ' ' + (item.product_type || '')).toLowerCase();
      if (KIDS_RE.test(text)) k++;
      else if (ADULTS_RE.test(text)) a++;
    });
    var total = cart.items.length;
    if (k / total > 0.6) return 'kids';
    if (a / total > 0.6) return 'adults';
    return 'mixed';
  }

  function updateRecsTitle(cart, gapMode) {
    var titleEl = $('.palmr-cd__recs-title');
    if (!titleEl) return;
    if (!titleEl.hasAttribute('data-base-title')) titleEl.setAttribute('data-base-title', titleEl.textContent);

    // Gap mode leads with the RELATIONSHIP, not the shortfall. Every apparel
    // brand surveyed titles this rail "Complete the Look"; none of them price it.
    // The gap arithmetic lives on the tile badge instead.
    if (gapMode) {
      var recsEl = $('[data-palmr-cd-recs]');
      var tpl = recsEl && recsEl.getAttribute('data-gap-title');
      if (tpl) {
        var first = (cart.items || []).filter(function (i) {
          return !(i.properties && i.properties._gift_tier);
        })[0];
        var type = (first && first.product_type ? String(first.product_type) : '').toLowerCase();
        // "Hats" -> "hat". Plural-only types stay plural ("Goes with your
        // joggers"); "Dresses" -> "dress". Unrecognised falls back to generic.
        if (/(?:shorts|pants|joggers|glasses|leggings)$/.test(type)) { /* keep as-is */ }
        else if (/sses$/.test(type)) type = type.slice(0, -2);
        else if (type.length > 3 && type.slice(-1) === 's') type = type.slice(0, -1);
        titleEl.textContent = type
          ? tpl.replace('{{product}}', type)
          : tpl.replace('your {{product}}', "what's in your cart").replace('{{product}}', 'cart');
        return;
      }
    }

    if (root.getAttribute('data-smart-title') !== 'true') {
      titleEl.textContent = titleEl.getAttribute('data-base-title');
      return;
    }
    var category = detectCartCategory(cart);
    var kidsTitle = root.getAttribute('data-smart-title-kids');
    var adultsTitle = root.getAttribute('data-smart-title-adults');
    var base = titleEl.getAttribute('data-base-title');
    if (category === 'kids' && kidsTitle) titleEl.textContent = kidsTitle;
    else if (category === 'adults' && adultsTitle) titleEl.textContent = adultsTitle;
    else titleEl.textContent = base;
  }

  /* ---------- Gap-closer rail ----------
     The rail used to be price-blind: at a $19 gap it offered $38/$38/$59/$75,
     none of which were sized to close it. This layer keeps Shopify's affinity
     ordering (intent=complementary) — the apparel convention is to merchandise
     by what goes together, not by price — and applies the gap as a silent
     FILTER, surfacing the arithmetic only as a per-tile badge.

     MARGIN GUARD: tier-1 gifts cost ~$10. A shopper closing a $5 gap with a $6
     koozie makes the order worse than not closing it, so nothing below the
     floor is ever surfaced as a gap-closer. It stays purchasable; we just never
     point at it. */

  // Ordered tiers with their display labels, read off the reward element.
  function rewardTiers() {
    var reward = $('[data-palmr-cd-reward]');
    if (!reward) return [];
    var defs = [
      { key: 'shipping', amt: 'data-shipping', lbl: 'data-shipping-label' },
      { key: '1', amt: 'data-tier1', lbl: 'data-tier1-label' },
      { key: '2', amt: 'data-tier2', lbl: 'data-tier2-label' }
    ];
    var out = [];
    defs.forEach(function (d) {
      var amount = parseInt(reward.getAttribute(d.amt), 10) || 0;
      if (amount > 0) out.push({ key: d.key, amount: amount,
                                 label: (reward.getAttribute(d.lbl) || '').toLowerCase() });
    });
    return out;
  }

  function nextRewardGap(qualifyingTotal) {
    var tiers = rewardTiers();
    if (!tiers.length) return null;
    for (var i = 0; i < tiers.length; i++) {
      if (qualifyingTotal < tiers[i].amount) {
        return { key: tiers[i].key, amount: tiers[i].amount,
                 gap: tiers[i].amount - qualifyingTotal };
      }
    }
    return null; // every tier earned — fall back to plain recommendations
  }

  // Non-gift line total, matching how the reward bar measures progress.
  function qualifyingTotalOf(cart) {
    var total = 0;
    (cart.items || []).forEach(function (i) {
      if (i.properties && i.properties._gift_tier) return;
      total += (i.final_line_price != null) ? i.final_line_price
             : (i.line_price != null) ? i.line_price
             : (i.price * i.quantity);
    });
    return total;
  }

  /* ---------- Bundle upsells (Complete the Look) ---------- */
  function getBundleIndex() {
    try {
      var el = document.getElementById('palmr-bundles-index');
      if (!el) return null;
      var raw = el.textContent.trim();
      if (!raw) return null;
      var idx = JSON.parse(raw);
      if (!idx || !Array.isArray(idx.bundles)) return null;
      return idx;
    } catch (e) { return null; }
  }

  function cartHasHandle(cart, handle) {
    return (cart.items || []).some(function (i) { return i.handle === handle; });
  }

  // One "add more" story at a time: recommendations only render when no
  // gift picker, pair upsell, or volume card is on screen. Every loader calls
  // syncUpsellPriority() when it settles, so whichever module wins, the recs
  // section yields to it (and reappears if the shopper dismisses everything).
  var recsHasContent = false;
  function anyPriorityUpsellVisible() {
    var vis = function (el) { return el && !el.hasAttribute('hidden'); };
    if ($$('[data-palmr-cd-gift-picker]').some(vis)) return true;
    if (vis($('[data-palmr-cd-upsells]'))) return true;
    if (vis($('[data-palmr-cd-volumes]'))) return true;
    return false;
  }
  function syncUpsellPriority() {
    var recs = $('[data-palmr-cd-recs]');
    if (!recs) return;
    if (recsHasContent && !anyPriorityUpsellVisible()) recs.removeAttribute('hidden');
    else recs.setAttribute('hidden', '');
  }

  function loadBundleUpsells(cart) {
    var container = $('[data-palmr-cd-upsells]');
    if (!container) return;
    var list = $('[data-palmr-cd-upsells-list]', container);
    if (!list) return;

    var index = getBundleIndex();
    if (!index) { container.setAttribute('hidden', ''); list.innerHTML = ''; syncUpsellPriority(); return; }

    var dismissed = getDismissedBundleIds();
    var suggestions = [];
    var seen = {};

    index.bundles.forEach(function (bundle) {
      if (bundle.enabled === false) return;
      if (bundle.type !== 'product_pair') return;
      if (bundle.id && dismissed[bundle.id]) return;
      var pa = bundle.products_a_resolved || bundle.products_a || [];
      var pb = bundle.products_b_resolved || bundle.products_b || [];

      // Customer has A but not B → suggest first B
      var hasAnyA = pa.some(function (h) { return cartHasHandle(cart, h); });
      var hasAnyB = pb.some(function (h) { return cartHasHandle(cart, h); });
      if (hasAnyA && !hasAnyB) {
        var pickHandle = pb[0];
        if (pickHandle && !seen[pickHandle]) {
          seen[pickHandle] = true;
          suggestions.push({ bundle: bundle, handle: pickHandle, side: 'b' });
        }
      } else if (hasAnyB && !hasAnyA) {
        var pickHandleA = pa[0];
        if (pickHandleA && !seen[pickHandleA]) {
          seen[pickHandleA] = true;
          suggestions.push({ bundle: bundle, handle: pickHandleA, side: 'a' });
        }
      }
    });

    if (!suggestions.length) {
      container.setAttribute('hidden', '');
      list.innerHTML = '';
      syncUpsellPriority();
      return;
    }

    Promise.all(suggestions.map(function (s) {
      return fetch('/products/' + encodeURIComponent(s.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p ? { suggestion: s, product: p } : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var html = '';
      results.forEach(function (r) {
        if (!r) return;
        var b = r.suggestion.bundle;
        var p = r.product;
        var variants = p.variants || [];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        // Side-aware copy (mirrors palmr-bundle-upsell.liquid): upsell_title is
        // written from the non-discounted side's perspective. When the cart
        // already holds the DISCOUNTED item and we're suggesting the other side
        // (e.g. hat in cart, suggesting sunglasses on the "free hat" pair),
        // flip to the direction-neutral message and rephrase the savings line
        // around the item already in the cart.
        var target = b.discount_target || 'b';
        var cartHoldsDiscounted = r.suggestion.side !== target;
        var eyebrow = escapeHtml(
          (cartHoldsDiscounted && (b.upsell_title_b || b.message)) || b.upsell_title || 'Complete the look'
        );
        var savePart;
        if (cartHoldsDiscounted && b.save_label_b) {
          savePart = b.save_label_b;
        } else if (b.value && b.value.kind === 'percentage') {
          if (cartHoldsDiscounted) {
            savePart = b.value.amount === 100
              ? 'Add this: <strong>the matching item in your cart goes FREE</strong>'
              : 'Add this: <strong>' + b.value.amount + '% off</strong> the matching item in your cart';
          } else {
            savePart = b.value.amount === 100
              ? '<strong>FREE</strong> when bought together'
              : '<strong>' + b.value.amount + '% off</strong> when bought together';
          }
        } else if (b.value && b.value.kind === 'fixed_amount') {
          savePart = cartHoldsDiscounted
            ? 'Add this: <strong>$' + b.value.amount + ' off</strong> the matching item in your cart'
            : '<strong>$' + b.value.amount + ' off</strong> when bought together';
        } else {
          savePart = '<strong>Bundle deal</strong>';
        }

        var ctaHtml = '';
        if (variants.length > 1) {
          var opts = '<option value="">Add</option>';
          variants.forEach(function (v) {
            opts += '<option value="' + v.id + '"' + (v.available === false ? ' disabled' : '') + '>' +
              escapeHtml(v.title) + (v.available === false ? ' — sold out' : '') + '</option>';
          });
          ctaHtml =
            '<select class="palmr-cd__upsell-cta" data-palmr-cd-upsell-add aria-label="Add ' + escapeHtml(p.title) + ' to cart">' +
            opts + '</select>';
        } else {
          var vid = variants[0] && variants[0].id;
          ctaHtml =
            '<button type="button" class="palmr-cd__upsell-cta" data-palmr-cd-upsell-add data-variant-id="' + vid + '">Add</button>';
        }

        var bundleIdAttr = b.id ? escapeHtml(b.id) : '';
        html +=
          '<li class="palmr-cd__upsell" data-palmr-cd-upsell data-handle="' + escapeHtml(p.handle) + '" data-bundle-id="' + bundleIdAttr + '">' +
          '  <a class="palmr-cd__upsell-image" href="' + escapeHtml(p.url) + '" aria-hidden="true" tabindex="-1" style="background-image:url(\'' + escapeHtml(img) + '\');"></a>' +
          '  <div class="palmr-cd__upsell-body">' +
          '    <p class="palmr-cd__upsell-eyebrow">' + eyebrow + '</p>' +
          '    <a class="palmr-cd__upsell-title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
          '    <p class="palmr-cd__upsell-save">' + savePart + '</p>' +
          '  </div>' +
          '  <div class="palmr-cd__upsell-actions">' +
          '    ' + ctaHtml +
          '    <button type="button" class="palmr-cd__upsell-dismiss" data-palmr-cd-bundle-dismiss="' + bundleIdAttr + '" aria-label="Dismiss this suggestion">No thanks</button>' +
          '  </div>' +
          '</li>';
      });
      list.innerHTML = html;
      if (html) container.removeAttribute('hidden');
      else container.setAttribute('hidden', '');
      syncUpsellPriority();
    });
  }

  // Volume tier progress cards — show one card per active volume bundle the
  // cart has at least one qualifying item from. Card shows: bundle name +
  // savings progress + a row of clickable product thumbnails pulled from the
  // bundle's primary collection so the shopper can browse and add more.
  var volumeCollectionCache = {};
  var volumeProductCache = {};

  function fetchCollectionProducts(handle) {
    if (!handle) return Promise.resolve([]);
    if (!volumeCollectionCache[handle]) {
      volumeCollectionCache[handle] = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=12', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) { return Array.isArray(data.products) ? data.products : []; })
        .catch(function () { return []; });
    }
    return volumeCollectionCache[handle];
  }

  function fetchProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (!volumeProductCache[handle]) {
      volumeProductCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return volumeProductCache[handle];
  }

  // Style family, keyed off the title prefix — "The 305 Signature Hat (Black)"
  // and "(Green)" are one family. Same key the PDP shelf uses.
  function styleFamily(product) {
    return String(product.title || '').split(' (')[0];
  }

  function fetchCollectionPreview(handle, excludeHandles, eligible) {
    return fetchCollectionProducts(handle).then(function (products) {
      var exclude = {};
      (excludeHandles || []).forEach(function (h) { exclude[h] = true; });
      var pool = products.filter(function (p) {
        if (!p || !p.handle || exclude[p.handle]) return false;
        return eligible ? !!eligible[p.handle] : true;
      });

      // Lead with one of each style, so three slots don't become three colours
      // of the same hat, then backfill in collection order.
      var seen = {};
      var picked = pool.filter(function (p) {
        var family = styleFamily(p);
        if (seen[family]) return false;
        seen[family] = true;
        return true;
      });
      pool.forEach(function (p) {
        if (picked.length < 3 && picked.indexOf(p) === -1) picked.push(p);
      });
      return picked.slice(0, 3);
    });
  }

  // Geo-matched thumbnails — same fix as the PDP shelf (palmr-bundle-upsell.liquid).
  // The bundle collection is manual-sorted 407-first, so a cart holding a 305 hat
  // was being pitched Orlando. Hats carry their area code as a bare three-digit
  // tag and every code has a `<code>-hats` collection, so the hats already in the
  // cart name the place to show more of.
  var GEO_COLLECTION_OVERRIDES = { '407': 'orlando-407-hats' }; // 407 predates the convention
  var GEO_TAG = /^\d{3}$/;

  // Resolves to a collection handle, or '' when the cart isn't repping one place:
  // no hat carries a code (Palmr Originals), or the cart mixes two area codes.
  // Hats carrying SEVERAL codes are the Florida-wide ones — they don't pin a
  // city, so they only decide the shelf when nothing else does.
  function resolveGeoCollection(handles) {
    return Promise.all(handles.slice(0, 4).map(fetchProductJson)).then(function (products) {
      var codes = [];
      var statewide = false;
      products.forEach(function (p) {
        if (!p || !Array.isArray(p.tags)) return;
        var own = p.tags.filter(function (t) { return GEO_TAG.test(t); });
        if (own.length > 1) { statewide = true; return; }
        if (own.length === 1 && codes.indexOf(own[0]) === -1) codes.push(own[0]);
      });

      var handle = '';
      if (codes.length === 1) handle = GEO_COLLECTION_OVERRIDES[codes[0]] || (codes[0] + '-hats');
      else if (!codes.length && statewide) handle = 'florida-hats';
      if (!handle) return '';

      // A handle that doesn't exist still answers 200 with an empty list.
      return fetchCollectionProducts(handle).then(function (found) {
        return found.length ? handle : '';
      });
    });
  }

  function loadVolumeBundleProgress(cart) {
    var container = $('[data-palmr-cd-volumes]');
    if (!container) return;
    var list = $('[data-palmr-cd-volumes-list]', container);
    if (!list) return;

    var index = getBundleIndex();
    if (!index || !Array.isArray(index.bundles)) {
      container.setAttribute('hidden', ''); list.innerHTML = ''; syncUpsellPriority(); return;
    }
    var dismissed = getDismissedBundleIds();
    var inCartHandles = (cart.items || []).map(function (i) { return i.handle; });

    // Units already discounted by a product_pair rule (e.g. the free hat from
    // "buy sunglasses, get a hat") don't count toward volume tiers — the
    // discount function excludes them, so the progress card must match.
    // Pair allocations are recognized by their checkout message; units are
    // derived from allocation amount ÷ per-unit discount.
    var pairValuesByMessage = {};
    index.bundles.forEach(function (b) {
      if (b && b.type === 'product_pair' && b.enabled !== false && b.message) {
        pairValuesByMessage[b.message] = b.value || null;
      }
    });
    function pairConsumedUnits(item) {
      var consumed = 0;
      (item.line_level_discount_allocations || []).forEach(function (a) {
        var app = a && a.discount_application;
        if (!app || !Object.prototype.hasOwnProperty.call(pairValuesByMessage, app.title)) return;
        var val = pairValuesByMessage[app.title];
        var unitDiscount = 0;
        if (val && val.kind === 'percentage') {
          unitDiscount = (item.price || 0) * ((parseFloat(val.amount) || 0) / 100);
        } else if (val && val.kind === 'fixed_amount') {
          unitDiscount = (parseFloat(val.amount) || 0) * 100;
        }
        consumed += unitDiscount > 0 ? Math.round((a.amount || 0) / unitDiscount) : 1;
      });
      return Math.min(consumed, item.quantity || 0);
    }

    // Build the list of bundles to render (preserves merchant order).
    var renderable = [];
    index.bundles.forEach(function (bundle) {
      if (!bundle || bundle.enabled === false) return;
      if (bundle.type !== 'product_volume') return;
      if (bundle.id && dismissed[bundle.id]) return;

      var products = bundle.products_resolved || bundle.products || [];
      if (!products.length) return;
      var productSet = {};
      products.forEach(function (h) { productSet[h] = true; });

      var qty = 0;
      var matched = [];
      (cart.items || []).forEach(function (item) {
        if (productSet[item.handle]) {
          qty += (item.quantity || 0) - pairConsumedUnits(item);
          if (matched.indexOf(item.handle) === -1) matched.push(item.handle);
        }
      });
      if (qty <= 0) return;

      var tiers = (bundle.tiers || []).slice().sort(function (a, b) {
        return (a.min_quantity || 0) - (b.min_quantity || 0);
      });
      if (!tiers.length) return;

      var current = null;
      var next = null;
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= (tiers[i].min_quantity || 0)) current = tiers[i];
        else if (!next) next = tiers[i];
      }
      renderable.push({ bundle: bundle, qty: qty, current: current, next: next, productSet: productSet, matched: matched });
    });

    if (!renderable.length) {
      container.setAttribute('hidden', ''); list.innerHTML = ''; syncUpsellPriority(); return;
    }

    // Fetch thumbnails in parallel, then render in merchant order. Prefer the
    // place the cart is already repping; fall back to the bundle collection
    // when there isn't one, or when the place has nothing left to show.
    Promise.all(renderable.map(function (entry) {
      var handle = entry.bundle.primary_collection && entry.bundle.primary_collection.handle;
      if (!handle || (entry.current && !entry.next)) return Promise.resolve([]);
      return resolveGeoCollection(entry.matched).then(function (geoHandle) {
        if (!geoHandle) return fetchCollectionPreview(handle, inCartHandles, null);
        // Scope the geo shelf to the bundle's own product list so it can never
        // pitch a hat this deal wouldn't actually discount.
        return fetchCollectionPreview(geoHandle, inCartHandles, entry.productSet).then(function (thumbs) {
          return thumbs.length ? thumbs : fetchCollectionPreview(handle, inCartHandles, null);
        });
      });
    })).then(function (thumbsList) {
      var html = '';
      renderable.forEach(function (entry, idx) {
        html += renderVolumeCard(entry.bundle, entry.qty, entry.current, entry.next, thumbsList[idx] || []);
      });
      list.innerHTML = html;
      if (html) container.removeAttribute('hidden');
      else container.setAttribute('hidden', '');
      syncUpsellPriority();
    });
  }

  function renderVolumeCard(bundle, qty, current, next, thumbs) {
    var displayName = (bundle.display_name && bundle.display_name.trim()) ||
      (bundle.primary_collection && bundle.primary_collection.title) ||
      'this bundle';
    var eyebrow = bundle.upsell_title || 'Bundle Deal';
    var bundleIdAttr = bundle.id ? escapeHtml(bundle.id) : '';
    var collectionHref = bundle.primary_collection && bundle.primary_collection.handle
      ? '/collections/' + encodeURIComponent(bundle.primary_collection.handle)
      : '';

    var headline, sub, pct, maxedClass = '';
    var nextSavings = next && next.savings_label ? next.savings_label : '';
    var currentSavings = current && current.savings_label ? current.savings_label : '';

    if (!current && next) {
      var need = (next.min_quantity || 0) - qty;
      headline = 'Add ' + need + ' more to save <strong>' + escapeHtml(nextSavings || '') + '</strong>';
      sub = qty + ' in cart · ' + (next.min_quantity || 0) + ' unlock' + ((next.min_quantity || 0) === 1 ? 's' : 's') + ' the deal';
      pct = Math.max(5, Math.round((qty / (next.min_quantity || 1)) * 100));
    } else if (current && next) {
      var need2 = (next.min_quantity || 0) - qty;
      headline = '✓ Saving <strong>' + escapeHtml(currentSavings) + '</strong> · Add ' + need2 + ' more for <strong>' + escapeHtml(nextSavings) + '</strong>';
      sub = qty + ' in cart · ' + (next.min_quantity || 0) + ' unlocks the next tier';
      pct = Math.max(50, Math.min(95, Math.round((qty / (next.min_quantity || 1)) * 100)));
    } else {
      headline = '✓ Saving <strong>' + escapeHtml(currentSavings) + '</strong> — top tier unlocked';
      sub = qty + ' in cart';
      pct = 100;
      maxedClass = ' palmr-cd__volume--maxed';
    }

    var thumbsHtml = '';
    if (thumbs && thumbs.length) {
      thumbsHtml += '<div class="palmr-cd__volume-thumbs">';
      thumbs.forEach(function (p) {
        var img = '';
        if (p.images && p.images[0]) {
          img = (typeof p.images[0] === 'string') ? p.images[0] : (p.images[0].src || '');
        }
        var url = '/products/' + encodeURIComponent(p.handle);
        thumbsHtml +=
          '<a class="palmr-cd__volume-thumb" href="' + url + '" title="' + escapeHtml(p.title || '') + '">' +
          '  <span class="palmr-cd__volume-thumb-img" style="background-image:url(\'' + escapeHtml(img) + '\');"></span>' +
          '  <span class="palmr-cd__volume-thumb-title">' + escapeHtml(p.title || '') + '</span>' +
          '</a>';
      });
      thumbsHtml += '</div>';
    }

    var titleHtml = collectionHref
      ? '<a class="palmr-cd__volume-title" href="' + collectionHref + '">' + escapeHtml(displayName) + ' →</a>'
      : '<p class="palmr-cd__volume-title">' + escapeHtml(displayName) + '</p>';

    return (
      '<li class="palmr-cd__volume' + maxedClass + '" data-palmr-cd-volume data-bundle-id="' + bundleIdAttr + '">' +
      '  <div class="palmr-cd__volume-head">' +
      '    <p class="palmr-cd__volume-eyebrow">' + escapeHtml(eyebrow) + '</p>' +
      '    <button type="button" class="palmr-cd__volume-dismiss" data-palmr-cd-bundle-dismiss="' + bundleIdAttr + '" aria-label="Dismiss this bundle">No thanks</button>' +
      '  </div>' +
      '  ' + titleHtml +
      '  <p class="palmr-cd__volume-headline">' + headline + '</p>' +
      '  <p class="palmr-cd__volume-sub">' + sub + '</p>' +
      '  <div class="palmr-cd__volume-bar"><div class="palmr-cd__volume-fill" style="width:' + pct + '%"></div></div>' +
      '  ' + thumbsHtml +
      '</li>'
    );
  }

  function loadRecommendations() {
    var recs = $('[data-palmr-cd-recs]');
    if (!recs) return;
    var list = $('[data-palmr-cd-recs-list]', recs);
    if (!list) return;
    var intent = recs.getAttribute('data-recs-intent') || 'complementary';
    var limit = parseInt(recs.getAttribute('data-recs-limit'), 10) || 3;

    getCart().then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        recsHasContent = false;
        recs.setAttribute('hidden', '');
        return;
      }
      var pid = cart.items[0].product_id;
      // Fetch DEEP, display shallow. Filtering a 3-product response by price
      // usually leaves nothing, so pull a wide affinity set once per product and
      // narrow it per render.
      var fetchLimit = Math.max(10, limit * 3);

      function paint(products) {
        var inCartIds = cart.items.map(function (i) { return i.product_id; });
        var pool = products.filter(function (p) { return inCartIds.indexOf(p.id) === -1; });
        var target = nextRewardGap(qualifyingTotalOf(cart));
        var gapMode = false;
        var shortlist = pool;

        if (recs.getAttribute('data-gap-enable') === 'true' && target) {
          var floor = (parseInt(recs.getAttribute('data-gap-floor'), 10) || 0) * 100;
          var closers = pool.filter(function (p) {
            var price = p.price_min !== undefined ? p.price_min : (p.price || 0);
            var buyable = (p.variants || []).some(function (v) { return v && v.available !== false; });
            return buyable && price >= target.gap && price >= floor;
          });
          // Order by SMALLEST SUFFICIENT, not by raw affinity rank.
          //
          // Affinity decides the pool (Shopify's complementary intent); price
          // decides the order within it. Leaving the API's order intact meant a
          // shopper $9 short was shown a $75 polo first — technically a
          // gap-closer, but an 8x bigger ask than they needed, which is the same
          // failure the price-blind rail had. Everything here is already
          // relevant, so ranking by how cheaply it closes the gap is not the
          // price-blind sort the apparel research warns against.
          if (closers.length) {
            closers.sort(function (a, b) {
              var pa = a.price_min !== undefined ? a.price_min : (a.price || 0);
              var pb = b.price_min !== undefined ? b.price_min : (b.price || 0);
              return pa - pb;
            });
            shortlist = closers;
            gapMode = true;
          }
          // No qualifying closer: fall through to plain recommendations rather
          // than showing an empty rail or pointing at something below the floor.
        }

        shortlist = shortlist.slice(0, limit);
        if (!shortlist.length) {
          recsHasContent = false;
          recs.setAttribute('hidden', '');
          return;
        }
        // The badge must name the tier THIS tile actually reaches. A fixed
        // string lied: at a $38 cart the next tier is free shipping, so a $25
        // tile reaches $63 — shipping, no gift — while the badge still claimed
        // a gift. Resolve the highest tier each tile clears, per tile.
        var badgeTpl = gapMode ? (recs.getAttribute('data-gap-badge') || '') : '';
        var allTiers = gapMode ? rewardTiers() : [];
        var cartTotal = qualifyingTotalOf(cart);
        function badgeFor(p) {
          if (!badgeTpl) return '';
          var price = p.price_min !== undefined ? p.price_min : (p.price || 0);
          var reached = null;
          allTiers.forEach(function (t) {
            if (t.amount > cartTotal && t.amount <= cartTotal + price) reached = t;
          });
          if (!reached) return '';
          return badgeTpl.replace(/\{\{reward\}\}/g, reached.label);
        }
        list.innerHTML = shortlist.map(function (p) { return renderRec(p, badgeFor(p)); }).join('');
        recs.removeAttribute('hidden');
        updateRecsTitle(cart, gapMode);
        recsHasContent = true;
        syncUpsellPriority();
      }

      if (pid === recsLoadedForProduct && recsProductCache) {
        // Same product, but the cart total (and therefore the gap) may have
        // moved — re-filter the cached pool instead of re-fetching.
        paint(recsProductCache);
        return;
      }
      recsLoadedForProduct = pid;
      var url = '/recommendations/products.json?product_id=' + pid + '&intent=' + encodeURIComponent(intent) + '&limit=' + fetchLimit;
      return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          recsProductCache = (data && data.products) || [];
          paint(recsProductCache);
        });
    }).catch(function (err) {
      console.warn('[palmr-cd] recs failed', err);
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderRec(p, badge) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var price = p.price_min !== undefined ? p.price_min : (p.price || 0);
    var variants = (p.variants || []).filter(function (v) { return v && v.id; });
    var hasMulti = variants.length > 1;

    var control;
    if (hasMulti) {
      var opts = variants.map(function (v) {
        var label = v.title || v.option1 || 'Variant';
        var avail = v.available !== false;
        return '<option value="' + v.id + '"' + (avail ? '' : ' disabled') + '>' +
               escapeHtml(label) + (avail ? '' : ' — sold out') + '</option>';
      }).join('');
      control =
        '<select class="palmr-cd__rec-select" data-palmr-cd-rec-select aria-label="Choose option for ' + escapeHtml(p.title) + '">' +
        '  <option value="">+ Add</option>' + opts +
        '</select>';
    } else {
      var variantId = variants[0] && variants[0].id;
      control = '<button type="button" class="palmr-cd__rec-add" data-palmr-cd-rec-add data-variant-id="' + variantId + '">+ Add</button>';
    }

    // High-contrast chip ON the tile (Instacart's "Spend $25, save $5"), not
    // caption text under the price where it reads as fine print.
    var badgeHtml = badge
      ? '<span class="palmr-cd__rec-unlock">' + escapeHtml(badge) + '</span>'
      : '';

    return '' +
      '<li class="palmr-cd__rec">' +
      '  <a class="palmr-cd__rec-image" href="' + escapeHtml(p.url) + '" tabindex="-1" aria-hidden="true">' +
      '    <img src="' + escapeHtml(img) + '&width=300" loading="lazy" alt="" width="110" height="110">' +
      '  </a>' +
      '  <div class="palmr-cd__rec-body">' +
      '    <a class="palmr-cd__rec-title" href="' + escapeHtml(p.url) + '" title="' + escapeHtml(p.title) + '">' + escapeHtml(p.title) + '</a>' +
      '    <div class="palmr-cd__rec-price">' + moneyFormat(price) + '</div>' +
           badgeHtml +
      '  </div>' +
      '  <div class="palmr-cd__rec-control">' + control + '</div>' +
      '</li>';
  }

  function addRecommendedVariant(variantId, control) {
    // control.disabled: onChange runs TWICE per <select> pick (it's bound to
    // both 'input' and 'change' for the qty inputs), and disabling the control
    // here doesn't cancel the already-queued second event.
    if (!variantId || isLoading || control.disabled) return;
    var origLabel;
    if (control.tagName === 'BUTTON') {
      origLabel = control.textContent;
      control.disabled = true;
      control.textContent = '…';
    } else if (control.tagName === 'SELECT') {
      control.disabled = true;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        return res.json();
      })
      .then(function (addedItem) {
        return getCart().then(function (cart) {
          return refresh();
        });
      })
      .catch(function () {
        showError("We couldn't add that to your cart. Please try again.");
        if (control.tagName === 'BUTTON') {
          control.disabled = false;
          control.textContent = origLabel || 'Add';
        } else {
          control.disabled = false;
          control.value = '';
        }
      });
  }

  /* ---------- Discount code (cart permalink) ---------- */
  function isCodeApplication(app) {
    if (!app) return false;
    var t = app.type || app.discount_application_type;
    return t === 'discount_code' || t === 'DiscountCodeApplication';
  }

  function findAppliedCode(cart) {
    // Order-level discount codes
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      if (isCodeApplication(apps[i]) && apps[i].title) {
        return { title: apps[i].title, total_allocated_amount: apps[i].total_allocated_amount || 0 };
      }
    }
    // Line-level discount codes (e.g. % off products) — sum allocations across lines
    var lines = (cart && cart.items) || [];
    var byCode = {};
    for (var j = 0; j < lines.length; j++) {
      var allocs = lines[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var alloc = allocs[k];
        var app = alloc.discount_application || {};
        if (isCodeApplication(app) && app.title) {
          byCode[app.title] = (byCode[app.title] || 0) + (alloc.amount || 0);
        }
      }
    }
    var codes = Object.keys(byCode);
    if (codes.length > 0) {
      return { title: codes[0], total_allocated_amount: byCode[codes[0]] };
    }
    return null;
  }

  function formatMoney(cents) {
    var d = (cents || 0) / 100;
    return '$' + (d === Math.floor(d) ? d.toFixed(0) : d.toFixed(2));
  }

  /* ---------- Session discount-code hygiene ----------
     Shopify's session discount cookie outlives the cart: /cart/update.js can
     drop a code from the cart JSON while leaving the cookie intact, and that
     cookie is what re-applies the code at checkout. Requesting an invalid
     discount permalink resets it.

     This used to run on EVERY checkout click that had no cart-visible code,
     which was wrong twice over. It added a redirect hop (~300-500ms measured)
     to the highest-intent click in the funnel for essentially every shopper,
     since automatic (Function) discounts never register as codes. And it wiped
     legitimate session codes that cart.js cannot see — free-shipping-only codes
     never appear in the cart's discount applications, so a FREESHIP link from
     email was being silently killed at checkout.

     Now the reset happens at removal time as a background fetch, and the
     checkout click only detours if that background reset actually failed. */
  var DISCOUNT_CLEAR_SENTINEL = 'PALMR-CLEAR-DO-NOT-CREATE-THIS-CODE';
  var DISCOUNT_CLEAR_FLAG = 'palmr_cd_clear_session_discount_v1';

  function needsSessionDiscountClear() {
    try { return sessionStorage.getItem(DISCOUNT_CLEAR_FLAG) === '1'; }
    catch (e) { return false; }
  }
  function setNeedsSessionDiscountClear(needed) {
    try {
      if (needed) sessionStorage.setItem(DISCOUNT_CLEAR_FLAG, '1');
      else sessionStorage.removeItem(DISCOUNT_CLEAR_FLAG);
    } catch (e) {}
  }

  function clearSessionDiscountCookie() {
    return fetch('/discount/' + encodeURIComponent(DISCOUNT_CLEAR_SENTINEL) + '?redirect=/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  function updateCheckoutHref(cart) {
    var checkout = $('[data-palmr-cd-checkout]');
    if (!checkout) return;
    var base = checkout.getAttribute('data-base-href');
    if (!base) {
      base = checkout.getAttribute('href') || '/checkout';
      checkout.setAttribute('data-base-href', base);
    }
    var applied = findAppliedCode(cart);
    if (applied) {
      // A code is live on the cart — never interfere with it, and there is
      // nothing stale left to clear.
      setNeedsSessionDiscountClear(false);
      checkout.setAttribute('href', base);
    } else if (needsSessionDiscountClear()) {
      // This session removed a code and the background cookie reset failed.
      // Fall back to clearing on the way through to checkout.
      checkout.setAttribute('href',
        '/discount/' + encodeURIComponent(DISCOUNT_CLEAR_SENTINEL) + '?redirect=' + encodeURIComponent(base));
    } else {
      // The common case: straight to checkout, no redirect hop.
      checkout.setAttribute('href', base);
    }
  }

  function renderDiscountStatus(cart, options) {
    options = options || {};
    var status = $('[data-palmr-cd-discount-status]');
    if (!status) return;
    var applied = findAppliedCode(cart);
    updateCheckoutHref(cart);

    if (applied) {
      status.innerHTML =
        '<span class="palmr-cd__discount-status-row palmr-cd__discount-status-row--ok">' +
        '  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>' +
        '  <strong>' + escapeHtml(applied.title) + '</strong> applied — ' + formatMoney(applied.total_allocated_amount) + ' off' +
        '  <button type="button" class="palmr-cd__discount-remove" data-palmr-cd-discount-remove aria-label="Remove discount code">Remove</button>' +
        '</span>';
      status.setAttribute('data-state', 'ok');
      updateDiscountToolButton(applied.title);
      var inp = $('[data-palmr-cd-discount-form] input[name="code"]');
      if (inp) inp.value = applied.title;
    } else if (options.error) {
      status.innerHTML =
        '<span class="palmr-cd__discount-status-row palmr-cd__discount-status-row--err">' +
        '  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>' +
        '  Code <strong>' + escapeHtml(options.error) + '</strong> is not valid' +
        '</span>';
      status.setAttribute('data-state', 'err');
      updateDiscountToolButton('');
    } else {
      status.innerHTML = '';
      status.removeAttribute('data-state');
      updateDiscountToolButton('');
    }
  }

  function updateDiscountToolButton(code) {
    var btn = $('[data-palmr-cd-tool="discount"]');
    if (!btn) return;
    var label = btn.querySelector('span');
    if (!label) return;
    if (!label.hasAttribute('data-base-label')) {
      label.setAttribute('data-base-label', label.textContent);
    }
    if (code) {
      label.textContent = 'Discount: ' + code + ' ✓';
    } else {
      label.textContent = label.getAttribute('data-base-label') || 'Apply Discount';
    }
  }

  function syncDiscountFromCart() {
    return getCart().then(function (cart) {
      renderDiscountStatus(cart);
    }).catch(function () {});
  }

  function onDiscountSubmit(e) {
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector('input[name="code"]');
    var raw = (input && input.value || '').trim();
    if (!raw) return;

    setLoading(true);
    // /discount/CODE sets the session discount cookie. ?redirect=/cart.js follows through to the cart JSON.
    fetch('/discount/' + encodeURIComponent(raw) + '?redirect=/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (cart) {
        if (!cart) return getCart();
        return cart;
      })
      .then(function (cart) {
        var applied = findAppliedCode(cart);
        if (applied && applied.title.toLowerCase() === raw.toLowerCase()) {
          // Applied — a live code means there is nothing stale to clear, so drop
          // any pending clear flag before it can strip this one at checkout.
          setNeedsSessionDiscountClear(false);
          // Gift lines are KEPT: codes and the gift Function's product discount
          // do combine (checkout-verified 2026-08-16: FREE GIFT −$38 + WELCOME15
          // on one order). If the code drops the post-discount total below the
          // tier, updateGiftPickers auto-removes the now-unearned gift on this
          // refresh — the targeted case, not a blanket strip.
          return refresh();
        }
        // Code did not apply. Show error.
        renderDiscountStatus(cart, { error: raw });
        setLoading(false);
      })
      .catch(function (err) {
        console.warn('[palmr-cd] discount apply failed', err);
        showError("We couldn't apply that code. Please try again.");
        setLoading(false);
      });
  }

  function onDiscountRemove() {
    setLoading(true);

    // Try multiple cart-clear methods in sequence — Shopify hasn't documented a
    // single canonical AJAX endpoint for clearing a discount code. Each method
    // is best-effort; we run them in order then check if cart.discount_code is empty.
    function tryUpdateDiscount(field) {
      var body = {};
      body[field] = '';
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
        cache: 'no-store'
      }).then(function (r) { return r.json().catch(function () { return null; }); });
    }

    tryUpdateDiscount('discount')
      .then(function (cart) {
        if (cart && !findAppliedCode(cart)) return cart;
        return tryUpdateDiscount('discount_code');
      })
      .then(function () {
        // Always finish with the permalink reset, even when the cart JSON already
        // looks clean: /cart/update.js clears the cart's view of the code but not
        // Shopify's session cookie, and the cookie is what re-applies it at
        // checkout. Doing it here as a background fetch keeps the cost off the
        // checkout click. If it fails, fall back to clearing via the checkout href.
        return clearSessionDiscountCookie()
          .then(function () { setNeedsSessionDiscountClear(false); })
          .catch(function () { setNeedsSessionDiscountClear(true); });
      })
      .catch(function () { setNeedsSessionDiscountClear(true); })
      .then(function () { return refresh(); })
      .catch(function () { setLoading(false); });
  }

  /* ---------- Shipping estimate ----------
     Auto-pulls the cheapest standard rate from Shopify Admin's configured shipping
     profile (no manual ZIP input). Free at $55+. Caches per-weight per-session to
     avoid re-hitting /cart/shipping_rates.json on every minor cart tick. */
  var SHIPPING_CACHE_KEY = 'palmr_shipping_estimate_v1';
  var SHIPPING_CACHE_TTL_MS = 30 * 60 * 1000;
  var SHIPPING_FREE_THRESHOLD_CENTS = 5500;
  var SHIPPING_DEFAULT_DEST = 'shipping_address[zip]=33701&shipping_address[country]=US&shipping_address[province]=FL';

  function readShippingCache(weight) {
    try {
      var raw = sessionStorage.getItem(SHIPPING_CACHE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || obj.weight !== weight) return null;
      if (Date.now() - obj.t > SHIPPING_CACHE_TTL_MS) return null;
      return obj.cents;
    } catch (e) { return null; }
  }
  function writeShippingCache(weight, cents) {
    try {
      sessionStorage.setItem(SHIPPING_CACHE_KEY, JSON.stringify({
        weight: weight, cents: cents, t: Date.now()
      }));
    } catch (e) {}
  }

  function renderShipping(state, label) {
    var row = $('[data-palmr-cd-shipping]');
    var val = $('[data-palmr-cd-shipping-value]');
    if (!row || !val) return;
    row.setAttribute('data-palmr-cd-shipping-state', state);
    val.removeAttribute('data-loading');
    val.textContent = label;
  }

  // shippingCents: null = unknown ("Calculated at checkout"), 0 = free, >0 = computed
  function renderTotals(cart, shippingCents) {
    var subtotalCents = cart ? (cart.total_price || 0) : 0;
    var originalCents = cart ? (cart.original_total_price || 0) : 0;
    var subEl = $('[data-palmr-cd-subtotal]');
    var savedEl = $('[data-palmr-cd-subtotal-saved]');
    var totEl = $('[data-palmr-cd-total]');
    var hintEl = $('[data-palmr-cd-shipping-hint]');

    if (subEl) subEl.textContent = moneyFormat(subtotalCents);

    if (savedEl) {
      if (originalCents > subtotalCents) {
        savedEl.textContent = ' (you saved ' + moneyFormat(originalCents - subtotalCents) + ')';
      } else {
        savedEl.textContent = '';
      }
    }

    if (hintEl) {
      if (cart && cart.item_count > 0 && subtotalCents < SHIPPING_FREE_THRESHOLD_CENTS) {
        var togo = SHIPPING_FREE_THRESHOLD_CENTS - subtotalCents;
        hintEl.textContent = ' (add ' + moneyFormat(togo) + ' to free shipping)';
      } else {
        hintEl.textContent = '';
      }
    }

    if (totEl) {
      var totalCents = subtotalCents + (shippingCents != null && shippingCents > 0 ? shippingCents : 0);
      totEl.textContent = moneyFormat(totalCents);
    }
  }

  function fetchShippingEstimate(cart) {
    if (!cart || cart.item_count === 0) {
      renderShipping('idle', '');
      renderTotals(cart, null);
      return;
    }
    if (cart.total_price >= SHIPPING_FREE_THRESHOLD_CENTS) {
      renderShipping('free', 'FREE');
      renderTotals(cart, 0);
      return;
    }
    var cached = readShippingCache(cart.total_weight);
    if (cached != null) {
      renderShipping('rate', moneyFormat(cached));
      renderTotals(cart, cached);
      return;
    }
    var val = $('[data-palmr-cd-shipping-value]');
    if (val) {
      val.setAttribute('data-loading', '1');
      val.textContent = 'Calculating…';
    }
    renderTotals(cart, null);
    fetch('/cart/shipping_rates.json?' + SHIPPING_DEFAULT_DEST, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('shipping_rates ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        var standard = rates
          .filter(function (r) { return !/pickup/i.test(r.name || ''); })
          .sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); })[0];
        if (!standard) {
          renderShipping('fallback', 'Calculated at checkout');
          renderTotals(cart, null);
          return;
        }
        var cents = Math.round(parseFloat(standard.price) * 100);
        writeShippingCache(cart.total_weight, cents);
        renderShipping('rate', moneyFormat(cents));
        renderTotals(cart, cents);
      })
      .catch(function () {
        renderShipping('fallback', 'Calculated at checkout');
        renderTotals(cart, null);
      });
  }

  /* ---------- Tool toggles (discount/shipping panels) ---------- */
  function toggleTool(name, btn) {
    var panels = $$('[data-palmr-cd-tool-panel]');
    var btns = $$('[data-palmr-cd-tool]');
    var opening = btn.getAttribute('aria-expanded') !== 'true';
    btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    panels.forEach(function (p) { p.setAttribute('hidden', ''); });
    if (opening) {
      btn.setAttribute('aria-expanded', 'true');
      var panel = $('[data-palmr-cd-tool-panel="' + name + '"]');
      if (panel) panel.removeAttribute('hidden');
    }
  }

  /* ---------- Cart line item handlers (unchanged) ---------- */
  function changeLine(key, quantity) {
    if (isLoading) return Promise.resolve();
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/change failed');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('palmr:cart-drawer:updated'));
        return refresh();
      })
      .catch(function (err) {
        console.warn('[palmr-cd] line change failed', err);
        showError("We couldn't update your cart. Please try again.");
        setLoading(false);
      });
  }

  /* ---------- Click delegation ---------- */
  function onClick(e) {
    var t = e.target;

    var closeTarget = t.closest('[data-palmr-cd-close], [data-palmr-cd-close-on-click]');
    if (closeTarget && root.contains(closeTarget)) {
      if (!closeTarget.matches('[data-palmr-cd-close-on-click]')) e.preventDefault();
      close();
      return;
    }

    var giftCollapse = t.closest('[data-palmr-cd-gift-collapse]');
    if (giftCollapse && root.contains(giftCollapse)) {
      e.preventDefault();
      if (isLoading) return;
      var collapseTier = giftCollapse.getAttribute('data-palmr-cd-gift-collapse');
      setGiftCollapsed(collapseTier, !giftCollapsed[collapseTier]);
      return;
    }

    var giftChange = t.closest('[data-palmr-cd-gift-change]');
    if (giftChange && root.contains(giftChange)) {
      e.preventDefault();
      setGiftChanging(giftChange.getAttribute('data-palmr-cd-gift-change'), true);
      return;
    }

    var giftCancel = t.closest('[data-palmr-cd-gift-cancel]');
    if (giftCancel && root.contains(giftCancel)) {
      e.preventDefault();
      if (!isLoading) setGiftChanging(giftCancel.getAttribute('data-palmr-cd-gift-cancel'), false);
      return;
    }

    var removeBtn = t.closest('[data-palmr-cd-remove]');
    if (removeBtn && root.contains(removeBtn)) {
      e.preventDefault();
      // Removing the Onboard keychain BY HAND is how a shopper declines it. Only
      // this path latches the flag — syncTbt1Gift's own cleanup (when the last
      // Onboard item leaves the cart) deliberately does not, so the keychain
      // comes back if they re-add Onboard product.
      if (removeBtn.closest('[data-gift-tier="' + TBT1_GIFT_TIER + '"]')) setTbt1Declined();
      changeLine(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    var qtyBtn = t.closest('[data-palmr-cd-qty]');
    if (qtyBtn && root.contains(qtyBtn)) {
      e.preventDefault();
      var dir = qtyBtn.getAttribute('data-palmr-cd-qty');
      var key = qtyBtn.getAttribute('data-key');
      var input = root.querySelector('[data-palmr-cd-qty-input][data-key="' + key + '"]');
      if (!input) return;
      var current = parseInt(input.value, 10) || 0;
      var next = dir === 'inc' ? current + 1 : Math.max(0, current - 1);
      changeLine(key, next);
      return;
    }

    var toolBtn = t.closest('[data-palmr-cd-tool]');
    if (toolBtn && root.contains(toolBtn)) {
      e.preventDefault();
      toggleTool(toolBtn.getAttribute('data-palmr-cd-tool'), toolBtn);
      return;
    }

    var recAddBtn = t.closest('[data-palmr-cd-rec-add]');
    if (recAddBtn && root.contains(recAddBtn)) {
      e.preventDefault();
      addRecommendedVariant(recAddBtn.getAttribute('data-variant-id'), recAddBtn);
      return;
    }

    var upsellAddBtn = t.closest('button[data-palmr-cd-upsell-add]');
    if (upsellAddBtn && root.contains(upsellAddBtn)) {
      e.preventDefault();
      addRecommendedVariant(upsellAddBtn.getAttribute('data-variant-id'), upsellAddBtn);
      return;
    }

    var upsellDismissBtn = t.closest('[data-palmr-cd-bundle-dismiss]');
    if (upsellDismissBtn && root.contains(upsellDismissBtn)) {
      e.preventDefault(); e.stopPropagation();
      var bundleId = upsellDismissBtn.getAttribute('data-palmr-cd-bundle-dismiss');
      setBundleDismissed(bundleId);
      var tile = upsellDismissBtn.closest('[data-palmr-cd-upsell], [data-palmr-cd-volume]');
      if (tile && tile.parentNode) tile.parentNode.removeChild(tile);
      var upsellContainer = $('[data-palmr-cd-upsells]');
      if (upsellContainer) {
        var remainingU = upsellContainer.querySelectorAll('[data-palmr-cd-upsell]');
        if (!remainingU.length) upsellContainer.setAttribute('hidden', '');
      }
      var volumeContainer = $('[data-palmr-cd-volumes]');
      if (volumeContainer) {
        var remainingV = volumeContainer.querySelectorAll('[data-palmr-cd-volume]');
        if (!remainingV.length) volumeContainer.setAttribute('hidden', '');
      }
      syncUpsellPriority();
      return;
    }

    var discountRemoveBtn = t.closest('[data-palmr-cd-discount-remove]');
    if (discountRemoveBtn && root.contains(discountRemoveBtn)) {
      e.preventDefault();
      var input = $('[data-palmr-cd-discount-form] input[name="code"]');
      if (input) input.value = '';
      onDiscountRemove();
      return;
    }

    // Grouped gift row: colourway / fit swatch. Each member already has its image,
    // price and pick control in the DOM tagged [data-gift-pane], so no variant data
    // lives in JS and the pick handlers below stay identical for grouped and flat
    // rows — only which pane is visible changes.
    //
    // Deliberately ABOVE the locked-picker catch-all: browsing colourways is the
    // point of the locked preview, so a swatch tap must not be swallowed and
    // turned into an "add $X more" flash. Only the pick control is gated.
    var giftSwatch = t.closest('[data-palmr-cd-gift-swatch]');
    if (giftSwatch && root.contains(giftSwatch)) {
      e.preventDefault();
      if (giftSwatch.disabled) return; // value sold out across the whole group
      var swatchGroup = giftSwatch.closest('[data-palmr-cd-gift-group]');
      if (!swatchGroup) return;
      selectGiftGroupMember(
        swatchGroup,
        giftSwatch.getAttribute('data-dim'),
        giftSwatch.getAttribute('data-value')
      );
      return;
    }

    var giftPickBtn = t.closest('button[data-palmr-cd-gift-pick]');
    if (giftPickBtn && root.contains(giftPickBtn)) {
      e.preventDefault();
      // Don't add from a locked preview — the tier isn't unlocked yet. Nudge the
      // "add $X more to unlock" note instead of dead-clicking.
      var lockedFromBtn = giftPickBtn.closest('.palmr-cd__gift-picker.is-locked');
      if (giftPickBtn.disabled || lockedFromBtn) {
        if (lockedFromBtn) flashEl(lockedFromBtn.querySelector('.palmr-cd__gift-locked-note') || lockedFromBtn);
        return;
      }
      pickGift(giftPickBtn.getAttribute('data-tier'), giftPickBtn.getAttribute('data-variant-id'));
      return;
    }

    // Locked gift preview: the pick control is disabled / pointer-events:none, so a
    // tap on the gift image or name lands on the picker itself and does nothing
    // (Clarity dead clicks on locked gift items, e.g. the Blue Trucker Hat, wk of
    // Jul 13). Treat any tap inside a locked picker as "why can't I add this?" and
    // flash the unlock note so the tap gets a response.
    var lockedGiftPicker = t.closest('.palmr-cd__gift-picker.is-locked');
    if (lockedGiftPicker && root.contains(lockedGiftPicker)) {
      e.preventDefault();
      flashEl(lockedGiftPicker.querySelector('.palmr-cd__gift-locked-note') || lockedGiftPicker);
      return;
    }

    var giftFocus = t.closest('[data-palmr-cd-gift-focus]');
    if (giftFocus && root.contains(giftFocus)) {
      e.preventDefault();
      var giftRow = giftFocus.closest('.palmr-cd__gift-item');
      var control = giftRow && giftRow.querySelector('[data-palmr-cd-gift-pick]:not([hidden]):not(:disabled)');
      if (!control) return;
      control.focus();
      flashEl(giftRow);
      if (control.tagName === 'SELECT') {
        if (typeof control.showPicker === 'function') {
          try { control.showPicker(); } catch (err) {}
        }
      } else {
        pickGift(control.getAttribute('data-tier'), control.getAttribute('data-variant-id'));
      }
      return;
    }

    // The reward progress block (markers / tier labels / progress message) is
    // status-only but looks tappable — customers click "Free Gift" / "Free Shipping"
    // expecting to claim or learn more, and nothing happens (Clarity dead clicks,
    // wk of Jun 22). The marker labels are pointer-events:none, so most real clicks
    // land on the block itself. Treat any click in the block as intent: jump to the
    // matching free-gift picker when one is unlocked & unclaimed, otherwise nudge the
    // progress message that explains how to unlock it.
    var rewardBlock = t.closest('[data-palmr-cd-reward]');
    if (rewardBlock && root.contains(rewardBlock)) {
      e.preventDefault();
      var rMarker = t.closest('[data-palmr-cd-reward-marker], [data-palmr-cd-reward-tier]');
      var rTier = rMarker && (rMarker.getAttribute('data-palmr-cd-reward-marker') || rMarker.getAttribute('data-palmr-cd-reward-tier'));
      if (rTier !== '1' && rTier !== '2') rTier = null; // shipping marker has no gift
      getCart().then(function (cart) {
        var state = getGiftState(cart);
        // Resolve which gift tier this click is about.
        var target = rTier;
        if (!target) {
          // No specific tier (clicked a label or the bar): the shopper's natural next
          // reward is the lowest tier they haven't claimed yet.
          ['1', '2'].some(function (tk) {
            var p = $('[data-palmr-cd-gift-picker="' + tk + '"]');
            if (!p || state.lines[tk].length > 0) return false;
            target = tk;
            return true;
          });
        }
        var picker = target && $('[data-palmr-cd-gift-picker="' + target + '"]');
        if (!picker) { flashEl($('[data-palmr-cd-reward-message]')); return; }
        var threshold = parseInt(picker.getAttribute('data-threshold'), 10);
        var qualifies = state.qualifyingTotal >= threshold;
        var hasGift = state.lines[target].length > 0;
        if (hasGift) { flashEl($('[data-palmr-cd-reward-message]')); return; } // already claimed
        // Unlocked → jump to claim it. Locked → toggle a non-addable preview of the options.
        if (!qualifies) giftPreview[target] = !giftPreview[target];
        setGiftCollapsed(target, false);
        updateGiftPickers(cart);
        if (qualifies || giftPreview[target]) {
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
          flashEl(picker);
        }
      }).catch(function () {});
      return;
    }
  }

  var qtyInputTimers = {};
  function onChange(e) {
    var t = e.target;
    if (!root.contains(t)) return;

    var recSelect = t.closest('[data-palmr-cd-rec-select]');
    if (recSelect) {
      var variantId = recSelect.value;
      if (variantId) {
        addRecommendedVariant(variantId, recSelect);
        recSelect.value = '';
      }
      return;
    }

    var upsellSelect = t.closest('select[data-palmr-cd-upsell-add]');
    if (upsellSelect) {
      var upsellVariantId = upsellSelect.value;
      if (upsellVariantId) {
        addRecommendedVariant(upsellVariantId, upsellSelect);
        upsellSelect.value = '';
      }
      return;
    }

    var giftSelect = t.closest('select[data-palmr-cd-gift-pick]');
    if (giftSelect) {
      if (giftSelect.closest('.palmr-cd__gift-picker.is-locked')) return; // locked preview
      // One user pick fires BOTH 'input' and 'change'. The first pass disables
      // the select, so this check is what makes the second pass a no-op — do
      // not rely on pickGift's isLoading guard alone (the historical
      // double-added-gift bug lived exactly here).
      if (giftSelect.disabled) return;
      var giftVariantId = giftSelect.value;
      if (giftVariantId) {
        giftSelect.disabled = true;
        pickGift(giftSelect.getAttribute('data-tier'), giftVariantId);
      }
      return;
    }

    var qtyInput = t.closest('[data-palmr-cd-qty-input]');
    if (qtyInput) {
      var key = qtyInput.getAttribute('data-key');
      clearTimeout(qtyInputTimers[key]);
      qtyInputTimers[key] = setTimeout(function () {
        var q = Math.max(0, parseInt(qtyInput.value, 10) || 0);
        changeLine(key, q);
      }, 350);
    }
  }

  function onSubmit(e) {
    var t = e.target;
    if (!root.contains(t)) return;
    if (t.matches('[data-palmr-cd-discount-form]')) onDiscountSubmit(e);
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      e.preventDefault();
      close();
    }
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
  document.addEventListener('cart-drawer:open', open);
  document.addEventListener('on:cart:add', function () { refresh().then(open); });

  root.addEventListener('click', onClick);
  root.addEventListener('input', onChange);
  root.addEventListener('change', onChange);
  root.addEventListener('submit', onSubmit);
  document.addEventListener('keydown', onKeydown);

  updateRewardBar();
  getCart().then(function (cart) {
    // Runs on every page, not just when the drawer opens: an Onboard item added
    // before this shipped (or from a surface that doesn't open the drawer) still
    // earns its keychain on the next page view.
    syncCartCount(cart);
    syncTbt1Gift(cart);
    renderDiscountStatus(cart);
    updateGiftPickers(cart);
    fetchShippingEstimate(cart);
  }).catch(function () {});

  window.PalmrCartDrawer = {
    open: open,
    close: close,
    refresh: refresh
  };
})();
